<template>
    <div class="line-14 default">
        <el-form label-position="right" label-width="110px" class="mt31" :model="formdata" ref='formdata' size='large' inline>
            <el-form-item label="平台" prop='type'>
                <el-select v-model="formdata.type" clearable placeholder="请选择">
                    <el-option v-for="item in platform_optionsata" :key="item.klpmid" :label="item.platform_name" :value="item.klpmid"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="达人昵称" prop='klurid'>
                <el-select v-model="formdata.klurid" filterable clearable remote :remote-method="getKolList" placeholder="请选择">
                    <el-option v-for="item in kol_options" :key="item.klurid" :label="item.nickname" :value="item.klurid"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否需要寄样" prop='is_send_sample'>
                <el-select v-model="formdata.is_send_sample" clearable placeholder="请选择">
                    <el-option v-for="item in isSendSampleArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="合作状态" prop='status'>
                <el-select v-model="formdata.status" clearable placeholder="请选择">
                    <el-option v-for="item in status_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form label-width="110px">
            <el-form-item>
                <el-button type="primary" @click="cpxDealList" size='medium'>搜索</el-button>
                <el-button @click="resetForm" size='medium'>重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list_data" :header-cell-style="{background: '#f9f9f9', color: '#333'}">
            <el-table-column label="达人信息" >
                <template slot-scope="scope">
                    <div class="flex">
                        <div class="">
                            <img class="page-goods-img" :src="scope.row.head_portrait" alt="">
                            <div v-if="scope.row.cxinklid"><el-tag type="primary" class="tag" size="mini" >意向达人</el-tag></div>
                        </div>
                        <div>
                            <div>平台：{{scope.row.type_name}}</div>
                            <div>达人昵称：{{scope.row.nickname}}
                                <el-popover v-if='!scope.row.home_link' placement="top-start" trigger="click" content="该达人主页还在完善哦">
                                    <span class='page-pointer fz-14' slot="reference">查看达人主页</span>
                                </el-popover>
                                <el-link class="fz-14" v-if="(scope.row.long_url||scope.row.home_link)" :href="scope.row.long_url?scope.row.long_url:scope.row.home_link" target="_blank" type="primary" :underline="false">查看达人主页</el-link>
                            </div>
                            <div>粉丝数：{{scope.row.fans?scope.row.fans:'暂无'}} <el-link class="fz-14" type="primary" :underline="false" v-if='(scope.row.type==1||scope.row.type==2)&&scope.row.luopan_id' @click="goFans(scope.row)">查看粉丝画像</el-link></div>
                            <div >达人排期：{{scope.row.kol_time_begin}}至{{scope.row.kol_time_end}}</div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="状态" width='300'>
                <template slot-scope="scope">
                    <div>合作状态：
                        <span v-if='scope.row.status==1' class="p-color-succ">待添加至合作名单</span> 
                        <span v-if='scope.row.status==2' class="p-color-succ">待上传采买报价
                            <el-tooltip :content="scope.row.reject_reason" v-if='scope.row.reject_reason' popper-class="item-tooltip" effect="dark" placement="top">
                                <span class="el-icon-warning p-color-danger"></span>
                             </el-tooltip>
                             <el-tooltip :content="scope.row.delete_remark" v-if='!scope.row.reject_reason && scope.row.delete_remark' popper-class="item-tooltip" effect="dark" placement="top">
                                <span class="el-icon-warning p-color-danger"></span>
                             </el-tooltip>
                        </span> 
                        <span v-if='scope.row.status==3' class="p-color-succ">待确认报价</span> 
                        <span v-if='scope.row.status==6' class="p-color-succ">待交付</span> 
                        <span v-if='scope.row.status==8' class="p-color-succ">效果数据待审核</span> 
                        <span v-if='scope.row.status==9' class="p-color-succ">合作完成</span> 
                        <span  v-if='scope.row.status==10' class="p-color-danger">终止合作
                            <el-tooltip :content="scope.row.stop_reason" v-if='scope.row.status==10' popper-class="item-tooltip" effect="dark" placement="top">
                                <span class="el-icon-warning p-color-danger"></span>
                            </el-tooltip>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 页码 -->
        <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
        <!-- 查看合作形式及报价 -->
        <lookcooperationoffer v-if='cooperation_flag' :look_cooperation='look_cooperation' @closeLookCooperation='closeLookCooperation'></lookcooperationoffer>
        <!-- 粉丝画像 -->
        <portraitfans v-if="isfans" :fansObj="fansObj" @closeMask ='isfans = false'></portraitfans>
    </div>
</template>
<script>
import utils from "@/utils/util.js";
import apiUrl from "@/config/api.js";
import pagePagination from "@/components/page_pagination.vue"
import lookcooperationoffer from "@/components/cpx/look_cooperation_offer.vue";
import portraitfans from "@/views/my/portrait_fans.vue"
export default {
    name:'partner_selected',
    components:{
        pagePagination,
        lookcooperationoffer,
        portraitfans
    },
    props:{
        cxorid:'',

    },
    data(){
        return{
            isfans: false,
            fansObj: {},
            api: {
                cpxDealList: "home/cpxDealList", 
                getKolPlatformList: "home/getKolPlatformList", 
                getKolUserList: "home/getKolUserList", 
            },
            pageData: {
                count: 0,
                page: 1,
                offset: 10
            },
            list_data:[],
            formdata:{
                type:'',//平台
                klurid:'',//达人昵称
                cooperation_type:'',
                promote_type:'',
                cps:'',//cps
                cpt_goods:'',//cpt带货
                cpt_recommended:'',//cpt种草
                cpa:'',//cpa
                cpc:'',//cpc
                promote_video:'',//推广形式-短视频
                promote_live:'',//推广形式-直播
                promote_other:'',//推广形式-其他
                is_send_sample:'',//是否需要寄样
                status:'',//合作状态
                special_param:'',
                orid:'',
                kol_status: 1,
            },
            platform_optionsata:[],//达人平台
            kol_options:[],//达人昵称列表
            cooperation_arr:[
                {value:'1',label:'CPS'},
                {value:'2',label:'CPT种草'},
                {value:'3',label:'CPT带货'},
                {value:'4',label:'CPA'},
                {value:'5',label:'CPC'},
            ],
            promote_arr:[
                {value:'1',label:'短视频'},
                {value:'2',label:'直播混播'},
                {value:'4',label:'直播专场'},
                {value:'3',label:'其他(图文等)'},
            ],
            status_arr:[
                {value:'2',label:'待上传采买报价'},
                {value:'3',label:'待确认报价'},
                {value:'6',label:'待交付'},
                {value:'8',label:'效果数据待审核'},
                {value:'9',label:'合作完成'},
                {value:'10',label:'终止合作'},
            ],
            isSendSampleArr:[
                {value:'2',label:'是'},
                {value:'1',label:'否'},
            ],
            look_cooperation:'', 
            cooperation_flag:false,        
        }
    },
    created(){
        this.cpxDealList()
        this.getKolPlatformList()
    },
    methods:{
        //获取列表
        cpxDealList(){
            let data= this.formdata
            data.cps=data.cooperation_type==1?'2':''//cps
            data.cpt_recommended=data.cooperation_type==2?'2':''//cpt种草
            data.cpt_goods=data.cooperation_type==3?'2':''//cpt带货
            data.cpa=data.cooperation_type==4?'2':''//cpa
            data.cpc=data.cooperation_type==5?'2':''//cpc
            data.promote_video = data.promote_type==1?'2':''//短视频
            data.promote_live = data.promote_type==2?'2':''//直播混播
            data.promote_live_special = data.promote_type==4?'2':''//直播专场
            data.promote_other = data.promote_type==3?'2':''//其他
            data.page=this.pageData.page
            data.offset = this.pageData.offset
            data.kol_status = 1
            data.orid=this.cxorid
            this.$http({
                method: "GET",
                url: this.api.cpxDealList,
                params: data
            }).then(res => {
                if (res.code == 1) {
                    this.list_data=res.data
                    this.list_data.forEach((item,index)=>{
                        item.kol_time_begin = item.kol_time_begin ? item.kol_time_begin.split(' ')[0] : ''
                        item.kol_time_end = item.kol_time_end ? item.kol_time_end.split(' ')[0] : ''
                    })
                    this.pageData.count = res.count || 0;  
                } else {
                    this.list_data = [];
                }
            });
        },
        resetForm(){
            this.$refs.formdata.resetFields()
        },
        // 分页改变
        pageChange(page, pageSize){
            this.pageData.page = page;
            this.pageData.offset = pageSize;
            this.cpxDealList();
        },
         // 达人列表
        getKolList(name){
            let _this = this;
            _this
                .$http({
                    method: "GET",
                    url: this.api.getKolUserList,
                    params: { nickname: name},
                    hideloading: true
                })
                .then(res => {
                    if (res.code == 1) {
                        _this.kol_options = res.data;
                    } else {
                        _this.$message.error(res.msg);
                    }
                })
                .catch(err => {
                console.log(err);
                });
        },

        // 导出
        exportOut(){
            let data = this.formdata
            if(this.cooperation_type){
                this.formdata.cps=this.cooperation_type==1?'2':''//cps
                this.formdata.cpt_recommended=this.cooperation_type==2?'2':''//cpt种草
                this.formdata.cpt_goods=this.cooperation_type==3?'2':''//cpt带货
                this.formdata.cpa=this.cooperation_type==4?'2':''//cpa
                this.formdata.cpc=this.cooperation_type==5?'2':''//cpc
            }
            if(this.promote_type){
                this.formdata.promote_video=this.promote_type==1?'2':''//短视频
                this.formdata.promote_live=this.promote_type==2?'2':''//直播混播
                this.formdata.promote_live_special = this.promote_type==4?'2':''//直播专场
                this.formdata.promote_other=this.promote_type==3?'2':''//其他
            }
            this.formdata.orid=this.cxorid
            let open_url = apiUrl.cpxDealList + "?auth_token=" +this.$http.getAuth("auth_token") + "&export=1&d=" + new Date().getTime();
            for (let key in data) {
                if (data[key]) {
                open_url += `&${key}=${data[key]}`;
                }
            }
            window.open(open_url, "_blank");
        },
        // 达人平台列表
        getKolPlatformList(){
            this.$http({
                method: "GET",
                url: this.api.getKolPlatformList,
                params: {}
            }).then(res => {
                if (res.code == 1) {
                    this.platform_optionsata = res.data.list
                }else{
                    this.$message.error(res.msg)
                }
            });
        },
    
        // 查看合作形式及报价
        getCooperation(row){
            this.cooperation_flag=true
            this.look_cooperation={
                cxdlid:row.cxdlid,
                klurid:row.klurid,
            }
        },
    
        closeLookCooperation(){
            this.cooperation_flag=false
        },
        goFans(row) {
            this.isfans = true;
            this.fansObj = row;
        }
    }
}
</script>
<style scoped>
    .mt31 {
        margin-top: 31px;
    }
    .fz-14{
        font-size: 14px;
        margin-top:-3px;
    }
    .flex{
        display: flex;
    }
   .tag{
        margin-right: 5px;
    }
    .imgbox{
         width: 80px;
        height: 80px;
        border:1px solid #ddd;
        margin-right: 10px;
    }
    .img{
        width: 80px;
        height: 80px;
    }
    .w-500{
        max-width: 500px;
    }
</style>